import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import intl from 'react-intl-universal';
import { Tooltip, IconButton } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import logger from 'utils/logger';
const propTypes = {
  updateBillStatus: PropTypes.func.isRequired,
  table: PropTypes.object.isRequired,
  refreshTableData: PropTypes.func.isRequired,
};

const log = logger.createLogger('StarLabel');

const StarLabel = ({ table, updateBillStatus, refreshTableData }) => {
  const selectedRows = table
    .getFilteredSelectedRowModel()
    .rows.map((row) => row.original);

  const newData = table.getRowModel().rows.map((row) => row.original);

  const setStarStatus = (status) => {
    const issueIds = selectedRows.map((row) => row.issueTitle);
    issueIds.forEach((issueId) => {
      const currentIssue = newData.find((row) => row.issueTitle === issueId);

      // Check if the currentIssue is a bill or a wage
      const isBill = currentIssue.view.billId !== undefined;
      const id = isBill ? currentIssue.view.billId : currentIssue.view.wageId;
      updateBillStatus(id, { starred: status });
    });
    refreshTableData();
    table.resetRowSelection();
  };

  return (
    <Fragment>
      <Tooltip
        title={intl.get('billing_for_sent_cases_toolbar_select_tooltip_star')}>
        <IconButton onClick={() => setStarStatus(true)}>
          <StarIcon />
        </IconButton>
      </Tooltip>
      <Tooltip
        title={intl.get(
          'billing_for_sent_cases_toolbar_select_tooltip_unstar'
        )}>
        <IconButton onClick={() => setStarStatus(false)}>
          <StarBorderIcon />
        </IconButton>
      </Tooltip>
    </Fragment>
  );
};

StarLabel.propTypes = propTypes;

export default StarLabel;
